import React, {useEffect, useState} from 'react';
import {Alert, Button, Card, Select} from "antd";
import {Shield} from "lucide-react";
import TaggableSelect from "@/components/select/apiSelect";
import toFaNumber from "@/lib/utils/number";
import {useApiUpdateAdminDiscountEvent} from "@/api/discount";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useApiSearchAdminTopics} from "@/api/topic";
import {useApiSearchAminCourses} from "@/api/course";
import {useApiSearchAdminGrades} from "@/api/grade";
import {useApiSearchAdminGroups} from "@/api/group";
import RenderIf from "@/components/render-if";
import {useApiSearchAdminCertifications} from "@/api/certification";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";

function DiscountEventSection({discountData, id}) {

    const [groups, setGroups] = useState([])
    const [grades, setGrades] = useState([])
    const [courses, setCourses] = useState([])
    const [topics, setTopics] = useState([])
    const [lessons, setLessons] = useState([])
    const [members, setMembers] = useState([])
    const [certifications, setCertifications] = useState([])
    const [event, setEvent] = useState('course_registration')

    useEffect(() => {
        if (discountData?.data?.data?.event) {
            setEvent(discountData?.data?.data?.event);
        }
        if (discountData?.data?.data?.events.length > 0) {
            setGroups(discountData?.data?.data?.events.filter(item => item.related === 'groups').map(item => item.related_id));
            setCourses(discountData?.data?.data?.events.filter(item => item.related === 'courses').map(item => item.related_id));
            setTopics(discountData?.data?.data?.events.filter(item => item.related === 'topics').map(item => item.related_id));
            setGrades(discountData?.data?.data?.events.filter(item => item.related === 'grades').map(item => item.related_id));
            setCertifications(discountData?.data?.data?.events.filter(item => item.related === 'certifications').map(item => item.related_id));
        }

    }, [discountData]);

    const {
        mutate: updateDiscountEvent,
        isPending: isPendingUpdateDiscountEvent,
        isSuccess: isSuccessUpdateDiscountEvent
    } = useApiUpdateAdminDiscountEvent()

    function onSave() {
        const eventData = {
            id: id,
            event: event,
            topics: topics,
            courses: courses,
            lessons: lessons,
            grades: grades,
            groups: groups,
            certifications: certifications,
        }


        updateDiscountEvent(eventData, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)
            },
            onError: (r) => {
                ApiHandleErrorMessage(r)
            }
        })
    }

    return (
        <div>
            <Card
                className="shadow-sm"
                title={
                    <div className="flex items-center gap-2">

                        <Shield size={20} className="text-gray-600"/>
                        <span>تنظیم رویداد</span>
                    </div>
                }
            >
                <span>تنظیم کنید این کد تخفیف در چه رویدادی فعال باشد
                </span>
                <div className={'mt-2'}>
                    <div className="flex my-2 gap-2 items-center">
                        <span>رویداد:</span>
                        <Select size="medium" onChange={(e) => setEvent(e)} value={event} className={'w-full '}>
                            <Select.Option value="course_registration">ثبت نام در کلاس</Select.Option>
                            <Select.Option value="pay_certification">پرداخت هزینه گواهی‌نامه ( به زودی )</Select.Option>
                        </Select>
                    </div>

                </div>

                <RenderIf condition={event === 'course_registration'}>
                    <Alert
                        message={'رویداد ثبت‌نام کلاس'}
                        showIcon={true}
                        description={<span>
                            این کد تخفیف قرار است در بخش ثبت‌نام کلاس‌ها مورد استفاده قرار گیرد.
                            <br/>
                         لطفا مشخص کنید که برای ثبت نام چه سرفصلی یا چه مقطع و رشته و گروه علمی میخواهید از این کد تخفیف استفاده شود.
                         <br/>
                         در صورتی که همزمان چند سرفصل و مقطع و رشته انتخاب شود سیستم هر کدام از آیتم‌ها را به صورت مستقل بررسی کرده و با اولین تطابق اجازه استفاده از کد تخفیف را به کاربر خواهد داد.
                        </span>} type="info"/>

                    <div className={'mt-2'}>
                        <TaggableSelect name={'group-search'} className={'mt-2'}
                                        label={'فعال برای گروه‌های'}
                                        searchFn={useApiSearchAdminGroups}
                                        onChange={setGroups}
                                        values={groups}
                                        render={(item) => {
                                            return toFaNumber(item.id) + ' - ' + item.title
                                        }}></TaggableSelect>

                        <TaggableSelect name={'grade-search'} className={'mt-2'}
                                        label={'فعال برای مقاطع تحصیلی'}
                                        searchFn={useApiSearchAdminGrades}
                                        onChange={setGrades}
                                        values={grades}
                                        render={(item) => {
                                            return toFaNumber(item.id) + ' - ' + item.title
                                        }}></TaggableSelect>

                        <TaggableSelect name={'course-search'} className={'mt-2'}
                                        label={'فعال برای رشته تحصیلی'}
                                        searchFn={useApiSearchAminCourses}
                                        onChange={setCourses}
                                        values={courses}
                                        render={(item) => {
                                            return toFaNumber(item.id) + ' - ' + item.title
                                        }}></TaggableSelect>


                        <TaggableSelect name={'topic-search'} className={'mt-2'}
                                        label={'فعال برای سرفصل‌های'}
                                        searchFn={useApiSearchAdminTopics}
                                        onChange={setTopics}
                                        values={topics}
                                        render={(item) => {
                                            return toFaNumber(item.id) + ' - ' + item.title
                                        }}></TaggableSelect>
                    </div>


                </RenderIf>

                <RenderIf condition={event === 'pay_certification'}>
                    <Alert
                        message={'رویداد پرداخت هزینه گواهی‌نامه'}
                        showIcon={true}
                        description={<span>
                            این کد تخفیف قرار است در بخش پرداخت هزینه گواهی‌نامه مورد استفاده قرار گیرد.
                            <br/>
                         لطفا مشخص کنید که برای پرداخت هزینه کدام گواهی‌نامه میخواهید از این کد تخفیف استفاده شود.

                        </span>} type="info"/>

                    <div className={'mt-2'}>
                        <TaggableSelect name={'certification-search'} className={'mt-2'}
                                        label={'فعال برای گواهی‌نامه'}
                                        searchFn={useApiSearchAdminCertifications}
                                        onChange={setCertifications}
                                        values={certifications}
                                        render={(item) => {
                                            return toFaNumber(item.id) + ' - ' + item.title
                                        }}></TaggableSelect>
                    </div>
                </RenderIf>

                <div className="flex">
                    <div className={'flex-1'}></div>
                    <div>
                        <Can permission={PermList.DISCOUNT_EDIT}>
                            <Button
                                loading={isPendingUpdateDiscountEvent}
                                variant={'solid'}
                                color={'primary'}
                                className="mt-2"
                                onClick={onSave}>ذخیره</Button>
                        </Can>
                    </div>
                </div>
            </Card>

        </div>
    );
}

export default DiscountEventSection;